import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import ReassignerGroup from "./ReassignerGroup";
import { useNavigate } from "react-router-dom";
import { initLightboxJS } from "lightbox.js-react";
import { SlideshowLightbox } from "lightbox.js-react";
import { Download } from "lucide-react";
import { apiFetch } from '../utils/apiClient';

function TachesEnAttente({
  user,
  socket,
  setAuthLoading,
  authLoading,
  demandeEnAttente,
  checkGroupAdmin,
  checkGroupRecMensuelle,
  checkGroupSeancePlacement,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  filterValue,
  setFilterValue,
  currentPage,
  setCurrentPage,
  totalPages,
  setTotalPages,
  filterNom,
  setFilterNom,
  acceptedByFilter,
  setAcceptedByFilter,
  nomFormulaire,
  setNomFormulaire,
  statusFilter,
  setStatusFilter,
  lieuFilter,
  setLieuFilter,
  assigneFilter,
  setAssigneFilter,
  messageErreurNom,
  messageErreur,
  messageErreurDate,
  setShouldFetch
}) {
  const [selectedForm, setSelectedForm] = useState(null);
  const [isAccepted, setIsAccepted] = useState(false);
  const [showReject, setshowReject] = useState(false);
  const [rejectComment, setRejectComment] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showComment, setShowComment] = useState("");
  const [errorShowComment, setErrorShowComment] = useState("");
  const [message, setMessage] = useState({ message: "", color: "" });
  const [showConfirm, setshowConfirm] = useState(false);
  const [showReassignPopup, setShowReassignPopup] = useState(false);
  const [errorReassign, setErrorReassign] = useState("");
  const [emailUser, setEmailUser] = useState("");
  const [nomUser, setNomUser] = useState("");
  const [idUser, setIdUser] = useState("");
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  // const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [recMensuelleGroupUserIds, setRecMensuelleGroupUserIds] = useState([]);
  const [excelDataEcole, setExcelDataEcole] = useState([]);
  const [listSpUsers, setListSpUsers] = useState([]);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: null,        // "processingDate" | "submissionDate"
    order: "asc",    // "asc" | "desc"
  });


  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/getUsers?nomFormulaire=${"Séance de placement"}`);
        if (!response.ok) throw new Error("Failed to fetch roles");
        const data = await response.json();
        setListSpUsers(data);
      } catch (err) {
        console.log(err.message);
      } 
    };

    // Initial fetch when the component mounts
    fetchRoles();
  }, []);

  useEffect(() => {
    // Si aucun des deux n'est vrai, on ne fait rien
    if (!checkGroupSeancePlacement && !checkGroupAdmin) return;

    const fetchExcelData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/listeDesEcoles`
        );
        if (!response.ok) {
          throw new Error("Erreur lors du fetch des données Excel");
        }

        const result = await response.json();
        setExcelDataEcole(result.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchExcelData();
  }, [checkGroupSeancePlacement, checkGroupAdmin]); // ⚡ dépendances


  useEffect(() => {
    const fetchGroupUsers = async () => {
      try {
        const response = await apiFetch(
          `${process.env.REACT_APP_API_BASE_URL}/getUsersInRecMensuelleGroup`
        );
        const data = await response.json();
        setRecMensuelleGroupUserIds(data.userIds || []);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des utilisateurs du groupe :",
          error
        );
      }
    };

    fetchGroupUsers();
  }, []);

  useEffect(() => {
    initLightboxJS("Insert_Your_License_Key_Or_Use_Default", "default");
  }, []);

  useEffect(() => {
  if (
    uploadedFile?.contentType === "application/pdf" &&
    uploadedFile?.data
  ) {
    try {

      //base64 → binaire → Blob → URL

      //Convertit le base64 → texte binaire
      const byteCharacters = atob(uploadedFile.data); 
      //Convertit chaque caractère en code numérique (byte)
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      //Transforme les nombres en vrai format binaire utilisable
      const byteArray = new Uint8Array(byteNumbers);

      //Crée un fichier PDF réel dans le navigateur
      const blob = new Blob([byteArray], {
        type: "application/pdf",
      });

      //Crée un lien temporaire vers ce fichier
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      return () => URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Erreur conversion PDF:", err);
    }
  }
}, [uploadedFile]);

  const fetchUploadedFile = async (numeroFormulaire) => {
  setLoadingFile(true);

  try {
    const response = await apiFetch(
      `${process.env.REACT_APP_API_BASE_URL}/uploadedFile/${numeroFormulaire}`
    );

    const data = await response.json(); // 🔥 TRÈS IMPORTANT

    setUploadedFile(data.uploadedFile);
    // setShowPopup(true);
    // ❌ Ne pas ouvrir le popup si ça finit par "-DP"
    if (!numeroFormulaire?.endsWith("-DP")) {
      setShowPopup(true);
    }
    return data.uploadedFile;
  } catch (error) {
    console.error("Erreur lors de la récupération du fichier", error);
  } finally {
    setLoadingFile(false);
  }
};

  const handleContinueClick = async (traite) => {
    if (!selectedForm) return;

    const { nomFormulaire } = selectedForm;

    switch (nomFormulaire) {
      case "Réclamation mensuelle de dépenses":

        setIsLoading(true);
        // sessionStorage.setItem("numeroFormulaire", selectedForm.numeroFormulaire);
        // sessionStorage.setItem("userId", selectedForm.userId);
        // sessionStorage.setItem("page", "Mes taches");

        // window.open("/formulaire", "_blank");
        const url = `/formulaire?numeroFormulaire=${selectedForm.numeroFormulaire}&page=Mes%20taches`;
        window.open(url, "_blank");
        closeModal();
        setIsLoading(false);
        break;

      case "Demande AEFO":
        setIsLoading(true);
        sessionStorage.setItem("numeroFormulaire", selectedForm.numeroFormulaire);
        sessionStorage.setItem("userId", selectedForm.userId);
        sessionStorage.setItem("page", "Mes taches");

        window.open("/formAefo", "_blank");
        closeModal();
        setIsLoading(false);

        break;


      case "Demande FEESO":
        setIsLoading(true);
        sessionStorage.setItem("numeroFormulaire", selectedForm.numeroFormulaire);
        sessionStorage.setItem("userId", selectedForm.userId);
        sessionStorage.setItem("page", "Mes taches");

        window.open("/formFeeso", "_blank");
        closeModal();
        setIsLoading(false);
        break;

      case "Demande SCFP":
        setIsLoading(true);
        sessionStorage.setItem("numeroFormulaire", selectedForm.numeroFormulaire);
        sessionStorage.setItem("userId", selectedForm.userId);
        sessionStorage.setItem("page", "Mes taches");

        window.open("/formScfp", "_blank");
        closeModal();
        setIsLoading(false);
        break;


      case "Achat équipement informatique":
        setIsLoading(true);
        try {
          navigate("/achatEquipInfo", {
            state: { selectedForm, page: "Mes taches", traite: traite },
          });
        } catch (error) {
          console.error("Error fetching form data:", error);
        } finally {
          setIsLoading(false); // Stop loading animation
        }
        break;

      case "Demande de projet":
        setIsLoading(true);
        try {
          const fileData = await fetchUploadedFile(selectedForm.numeroFormulaire);

          if (!fileData) {
            throw new Error("Fichier introuvable");
          }
          const enrichedForm = {
            ...selectedForm,
            uploadedFile: fileData,
          };

          navigate("/demandeProjet", {
            state: { selectedForm:enrichedForm, page: "Mes taches", traite: traite },
          });
        } catch (error) {
          console.error("Error fetching form data:", error);
        } finally {
          setIsLoading(false); // Stop loading animation
        }
      break;

      case "Accès hors pays":
        setIsLoading(true);
        try {
          navigate("/Acceshorspays", {
            state: { selectedForm, page: "Mes taches", traite: traite },
          });
        } catch (error) {
          console.error("Error fetching form data:", error);
        } finally {
          setIsLoading(false); // Stop loading animation
        }
        break;
      default:
        console.warn("Formulaire non reconnu:", nomFormulaire);
    }
  };

  const handleReassignClick = () => {
    setShowReassignPopup(true);
  };

  const handleReassignConfirm = (_id, nomFormulaire) => {
    if (nomUser === "") {
      setErrorReassign("ce champs est requis");
    } else {
      setShowReassignPopup(false);
      // console.log(_id, nomFormulaire, nomUser, idUser, emailUser);
      changeRequest(
        selectedForm._id,
        selectedForm.nomFormulaire,
        "En traitement"
      );
    }
  };

  const handleReassignCancel = () => {
    setShowReassignPopup(false);
    setNomUser("");
    setEmailUser("");
    setIdUser("");
    setErrorReassign("");
  };

  const handleUserSelect = (user) => {
    if (user) {
      setErrorReassign("");
      setNomUser(user.nom);
      setEmailUser(user.email);
      setIdUser(user.userId);
    } else {
      setNomUser("");
      setEmailUser("");
      setIdUser("");
    }

  };



  // Filter requests based on the form number
  // const filteredData = (
  //   Array.isArray(demandeEnAttente) ? demandeEnAttente : []
  // ).filter((form) => {
  //   return (
  //     // form.numeroFormulaire.toLowerCase().includes(filterValue.toLowerCase()) &&
  //     form.nom.toLowerCase().includes(filterNom.toLowerCase()) &&
  //     (statusFilter === "" || form.etatDemande === statusFilter) &&
  //     (nomFormulaire === "" || form.nomFormulaire === nomFormulaire) &&
  //     (acceptedByFilter === "" ||
  //       (form.traitant &&
  //         form.traitant.length > 0 &&
  //         form.traitant[form.traitant.length - 1].userId.includes(user.id))) // Filtre "Moi" ou "Tous le monde"
  //     // isWithinDateRange // Filtre par intervalle de dates
  //   );
  // });

  // const currentData = demandeEnAttente;


  const handleSort = (columnKey) => {
    setSortConfig((prev) => ({
      key: columnKey,
      order:
        prev.key === columnKey && prev.order === "asc"
          ? "desc"
          : "asc",
    }));
  };

  // const sortedDemandes = [...demandeEnAttente].sort((a, b) => {
  //   if (!sortConfig.key) return 0;

  //   const getValue = (item) => {
  //     if (sortConfig.key === "processingDate") {
  //       return new Date(item.traitant[item.traitant.length - 1]?.dateHeure || 0);
  //     }

  //     if (sortConfig.key === "submissionDate") {
  //       return new Date(item.dateSoumission || 0);
  //     }

  //     return 0;
  //   };

  //   const valA = getValue(a);
  //   const valB = getValue(b);

  //   return sortConfig.order === "asc"
  //     ? valA - valB
  //     : valB - valA;
  // });

  // // Calculer les indices pour la pagination
  // const startIndex = (currentPage - 1) * 25;
  // const endIndex = startIndex + 25;
  // const currentData = sortedDemandes.slice(startIndex, endIndex);

  // ✅ En dehors du composant
const tabs = [
  { label: "À traiter" },
  { label: "Approuvé" },
  { label: "Rejeté" },
  { label: "Soumis" },
];

const getTabBadgeColor = (label) => {
  switch (label) {
    // case "En attente":    return "bg-orange-100 text-orange-700";
    case "À traiter": return "bg-yellow-100 text-yellow-700"; 
    case "Soumis":        return "bg-blue-100 text-blue-700";
    case "Approuvé":      return "bg-green-100 text-green-700";
    case "Rejeté":        return "bg-red-100 text-red-700";
    default:              return "bg-gray-100 text-gray-600";
  }
};

// ✅ À l'intérieur du composant
const [activeTab, setActiveTab] = useState("À traiter");
// const tabFilteredData = currentData.filter(form => form.etatDemande === activeTab);

  const sortedDemandes = [...demandeEnAttente].sort((a, b) => {
  if (!sortConfig.key) return 0;

  const getValue = (item) => {
    if (sortConfig.key === "processingDate")
      return new Date(item.traitant[item.traitant.length - 1]?.dateHeure || 0);
    if (sortConfig.key === "submissionDate")
      return new Date(item.dateSoumission || 0);
    return 0;
  };

  const valA = getValue(a);
  const valB = getValue(b);
  return sortConfig.order === "asc" ? valA - valB : valB - valA;
});

// Filtrer par onglet AVANT la pagination
const tabSortedData =
  activeTab === "À traiter"
    ? sortedDemandes.filter(
        (f) =>
          f.etatDemande === "En attente" ||
          f.etatDemande === "En traitement"
      )
    : sortedDemandes.filter(
        (f) => f.etatDemande === activeTab
      );

// Paginer sur les données filtrées
const startIndex = (currentPage - 1) * 15;
const endIndex = startIndex + 15;
const currentData = tabSortedData.slice(startIndex, endIndex);
// setTotalPages(Math.ceil(tabSortedData.length / 15)) 
useEffect(() => {
  setTotalPages(Math.ceil(tabSortedData.length / 15));
}, [tabSortedData]);


  // Fonction pour changer la page
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const changeRequest = async (
    _id,
    nomFormulaire,
    etatDemande,
    courrielDemandeur,
    numeroFormulaire
  ) => {
    // console.log("Accept request : ", _id);
    // console.log("here is the email",courrielDemandeur)
    if (
      (etatDemande === "Rejeté" && !rejectComment.trim()) ||
      (etatDemande === "Rejeté" && !showComment.trim())
    ) {
      setErrorMessage("champs requis");
      return;
    } else {
      try {
        const response = await apiFetch(
          `${process.env.REACT_APP_API_BASE_URL}/modify-etatdemande/${_id}`,
          {
            method: "PUT", // or 'POST' depending on your backend setup
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              etatDemande,
              nomFormulaire: nomFormulaire,
              userId: idUser ? idUser : user.id,
              nom: nomUser ? nomUser : user.displayName,
              email: emailUser ? emailUser : user.mail,
              commentaire: nomUser ? `demande réassignée` : rejectComment,
              commentaireVisible: showComment,
              courrielDemandeur,
              numeroFormulaire,
            }), // Update this value as needed
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update request status");
        }

        // ✅ Emit to server that a request has changed
        if (socket) {
          socket.emit("requestUpdated");
        }

        setSelectedForm(null);
        setshowReject(false);
        setRejectComment("");
        setShowComment("");
        if (etatDemande === "En traitement" && nomUser) {
          setMessage({
            message: "La demande a été réassignée",
            color: "text-green-600",
          });
        } else if (etatDemande === "En traitement") {
          setMessage({
            message: "La demande a été Acceptée",
            color: "text-green-600",
          });
        } else if (etatDemande === "Approuvé") {
          setMessage({
            message: "La demande a été Approuvée",
            color: "text-green-600",
          });
        } else if (etatDemande === "Rejeté") {
          setMessage({
            message: "La demande a été Rejetée",
            color: "text-red-600",
          });
        }
        handleReassignCancel();
        setIsAccepted(true);
        setTimeout(() => {
          setIsAccepted(false);
        }, 3000);
      } catch (error) {
        console.error("Error updating request status:", error);
      }
    }
  };

  
const handleCloturerClick = async (_id) => {
     try {
        const response = await apiFetch(
          `${process.env.REACT_APP_API_BASE_URL}/cloturerDemandeProjet/${_id}`,
          {
            method: "PUT", // or 'POST' depending on your backend setup
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update request status");
        }

        // ✅ Emit to server that a request has changed
        if (socket) {
          socket.emit("requestUpdated");
        }

        setSelectedForm(null);
        
        setMessage({
          message: "La demande a été cloturée",
          color: "text-blue-600",
        });
        
        setIsAccepted(true);
        setTimeout(() => {
          setIsAccepted(false);
        }, 3000);
      } catch (error) {
        console.error("Error updating request status:", error);
      }
  };

  // Fonction pour ouvrir le modal et afficher les détails de l'élément sélectionné
  const handleRowClick = (form) => {
    setSelectedForm(form);
  };

  // Fonction pour fermer le modal
  const closeModal = () => {
    setSelectedForm(null); // Réinitialiser l'élément sélectionné
  };
  const closePopup = () => {
    setShowPopup(false);
  };

  const Field = ({ label, value, isPassword, showPassword, setShowPassword }) => {
  return (
    <div>
      <div className="block text-sm font-medium text-blue-900 mb-1">{label}</div>

      <div className="relative mt-1 w-4/5 p-3 border border-gray-200 rounded-xl
                   bg-white shadow-sm
                   break-words whitespace-pre-wrap">
        {isPassword ? (
          <>
            <span>
              {showPassword ? value : "••••••••••"}
            </span>

            {/* <button
              type="button"
              onClick={() => setShowPassword(prev => !prev)}
              className="ml-2 text-gray-500 hover:text-gray-700"
              aria-label={showPassword ? "Masquer" : "Afficher"}
            >
              {showPassword ? "🙈" : "👁️"}
            </button> */}

            <button
                      type="button"
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                      aria-label={
                        showPassword
                          ? "Masquer le mot de passe"
                          : "Afficher le mot de passe"
                      }
                    >
                      {showPassword ? (
                        // Eye-off icon
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9.27-3.11-11-7
               1.02-2.32 2.82-4.27 5.125-5.675M6.1 6.1A9.969 9.969 0 0112 5
               c5 0 9.27 3.11 11 7a10.97 10.97 0 01-4.145 5.355M15 12a3 3 0 01-3 3
               m0-6a3 3 0 013 3m6 6L4 4.5"
                          />
                        </svg>
                      ) : (
                        // Eye icon
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5
               c4.478 0 8.268 2.943 9.542 7
               -1.274 4.057-5.064 7-9.542 7
               -4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                      )}
                    </button>
          </>
        ) : (
          value
        )}
      </div>
    </div>
  );
};


const formatDateTime = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};
const formatPhone = (phone) => {
  if (!phone || phone.length < 10) return phone;
  return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 10)}`;
};

const renderGrid = (fields) => {
  const visibleFields = fields.filter(
    (f) => f.value !== undefined && f.value !== null && f.value !== ""
  );

  if (visibleFields.length === 0) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
      {visibleFields.map((f, i) => (
        <Field
          key={i}
          label={f.label}
          value={f.value}
          isPassword={f.isPassword}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
        />
      ))}
    </div>
  );
};

  const renderFormDetails = (form) => (
    <div className="space-y-6">
      <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
        {/* === Informations générales === */}
      {renderGrid([
        { label: "Formulaire", value: form.nomFormulaire },
        { label: "Numéro de formulaire", value: form.numeroFormulaire },
        { label: "Nom", value: form.nom },
        { label: "Courriel", value: form.courriel },
        { label: "Poste", value: form.posteOccupe },
        { label: "Matricule centrale", value: form.matricule },
        { label: "Date de soumission", value: formatDateTime(form.dateSoumission) },
        { label: "État de la demande", value: form.etatDemande },
      ])}

        {/* === Membre du personnel === */}
      {renderGrid([
        { label: "Nom du membre du personnel", value: form.nomMembre },
        { label: "Prénom du membre du personnel", value: form.prenomMembre },
        { label: "Poste du membre du personnel", value: form.posteMembre },
        { label: "Lieu de travail", value: form.lieuTravail },
      ])}

     {/* === Déclaration === */}
      {renderGrid([
         {
    label: "Type de la demande",
    value:
      form?.typeDemande
        ? form.typeDemande === "rapportPolice"
          ? "Rapport de police"
          : "Déclaration annuelle des antécédents criminels"
        : null,
  },
        {
          label: "Coupable",
          value: form.coupable,
        },
        {
    label: "Type de document",
    value:
      form?.typeDocument
        ? form.typeDocument === "RecuDemande"
          ? "Accusé de réception de la demande de certificat de police"
          : "Certificat de police"
        : null,
  },
        {
          label: "Dat de document",
          value: form.dateDocumentPolice,
        },   
         {
          label: "Mot de passe",
          value: form.motdepasseFile,
          isPassword: true,
        },
        {
          label: "Déclaration exacte et complète",
          value: form.declarationExacteEtComplete,
        }
      ])}

       
        {form.adressePostalResidentielle === "non" && (
          <p className="mt-3 block text-lg font-medium text-blue-900 pt-5">
            <strong>Adresse Résidentielle </strong>
          </p>
        )}

        {/* === Adresse résidentielle === */}
      {renderGrid([
        { label: "Adresse", value: form.adresse },
        { label: "Appartement", value: form.numeroappartement },
        { label: "Ville", value: form.ville },
        { label: "Province", value: form.province },
        { label: "Code postal", value: form.codePostal },
      ])}

        {form.adressePostalResidentielle === "non" && (
          <p className="mt-3 block text-lg font-medium text-blue-900 pt-5">
            <strong>Adresse Postale </strong>
          </p>
        )}

        {form.adressePostalResidentielle === "non" && (
        <>

          {renderGrid([
            { label: "Boîte postale", value: form.boitePostale },
            { label: "Appartement / unité", value: form.appartementPostale },
            { label: "Ville", value: form.villePostale },
            { label: "Province", value: form.provincePostale },
            { label: "Code postal", value: form.codePostalPostale },
          ])}
        </>
      )}


        {/* === Coordonnées === */}
      {renderGrid([
        {
          label: "Numéro de téléphone principal",
          value: formatPhone(form.telephone),
        },
        {
          label: "Autre numéro de téléphone",
          value: formatPhone(form.telephoneCellulaire),
        },
        { label: "Date d’entrée en vigueur", value: form.dateEntreeEnVigueur },
      ])}

        {/* === Dates & superviseur === */}
      {renderGrid([
        { label: "Date de début", value: form.dateDebut },
        { label: "Date de fin", value: form.dateFin },
        {
          label: "Courriel du superviseur",
          value: form.courrielSuperviseur,
        },
      ])}

        {/* === Commentaires === */}
      {form.commentairesDemandeur && (
        <div className="pt-6">
          <label className="block text-sm font-medium text-blue-900 mb-1">
            Commentaires du demandeur :
          </label>
          <div className="p-3 border border-gray-200 rounded-xl bg-white whitespace-pre-wrap break-words">
            {form.commentairesDemandeur}
          </div>
        </div>
      )}


        {/* === Changement de nom === */}
      {renderGrid([
        { label: "Nouveau nom", value: form.nouveauNom },
        { label: "Nouveau prénom", value: form.nouveauPrenom },
        { label: "Deuxième prénom", value: form.deuxiemePrenom },
      ])}

        {/* === Banque === */}
      {renderGrid([
        { label: "Institution", value: form.institution },
        { label: "Banque", value: form.banque },
        { label: "Numéro de transit", value: form.numeroTransit },
        { label: "Numéro de compte", value: form.numeroCompte },
      ])}

      {/* === Réclamation === */}
      {renderGrid([
        {
          label: "Période de la réclamation",
          value: form.periodReclamation
            ? new Intl.DateTimeFormat("fr-CA", {
                year: "numeric",
                month: "long",
                timeZone: "UTC",
              }).format(new Date(form.periodReclamation))
            : null,
        },
        {
          label: "Document justificatif",
          value: form.documentJustificatif,
        },
      ])}

 {/* Bouton pour voir le fichier */}
        {(form.nomFormulaire==="Changement information bancaire"||
        form.nomFormulaire==="Changement nom"||
        form.nomFormulaire==="Antécédents criminels")
         && (
        <div className="mt-4 w-3/4 flex items-center">
  <button
    onClick={() => fetchUploadedFile(form.numeroFormulaire)}
    className="mt-5 flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 text-white font-medium shadow-md hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] transition-all duration-200"
  >
    {loadingFile ? (
      <span className="animate-pulse">Chargement...</span>
    ) : (
      <>
        📄 <span>Voir le document</span>
      </>
    )}
  </button>
</div>
        )}
{showPopup && (
  <>
    {/* BACKDROP */}
    <div
      className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
      onClick={closePopup}
    ></div>

    {/* MODAL */}
    <div className="fixed w-[65%] max-w-5xl h-[85%] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden">

      {/* HEADER */}
      <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
        <div>
          <h3 className="text-lg font-semibold text-gray-800">
            Aperçu du fichier
          </h3>
          <p className="text-xs text-gray-500">
            Visualisation rapide du document
          </p>
        </div>

        <button
          onClick={closePopup}
          className="text-gray-400 hover:text-gray-700 text-xl transition"
        >
          ✕
        </button>
      </div>

      {/* BODY */}
      <div className="flex-1 overflow-auto p-6 flex justify-center items-center bg-gray-50">

        {/* LOADING */}
        {!uploadedFile && (
          <div className="flex flex-col items-center gap-3 text-gray-500">
            <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            <p>Chargement du fichier...</p>
          </div>
        )}

        {/* IMAGE */}
        {uploadedFile?.contentType?.startsWith("image/") && (
          <div className="space-y-4 text-center">
            <div className="mt-10 flex items-center justify-center gap-3 text-sm text-white font-medium bg-green-700 backdrop-blur px-4 py-2 rounded-full shadow-sm">
              <span>Télécharger :</span>
              <a
                href={`data:${uploadedFile.contentType};base64,${uploadedFile.data}`}
                download
                className="p-2 rounded-full bg-white shadow hover:bg-gray-100 transition"
              >
                <Download className="w-4 h-4 text-gray-700" />
              </a>
            </div>

            <SlideshowLightbox>
              <img
                src={`data:${uploadedFile.contentType};base64,${uploadedFile.data}`}
                alt="Aperçu"
                className="max-h-[500px] rounded-xl shadow-md border cursor-zoom-in hover:scale-[1.02] transition"
              />
            </SlideshowLightbox>
          </div>
        )}

        {/* PDF */}
        {uploadedFile?.contentType === "application/pdf" && pdfUrl && (
  <iframe
    src={pdfUrl}
    title="PDF preview"
    className="w-full h-[90%] border mt-4 rounded-lg"
  />
)}
        {/* {uploadedFile?.contentType === "application/pdf" && (
          <iframe
            src={`data:application/pdf;base64,${uploadedFile.data}`}
            title="PDF preview"
            className="w-full h-full rounded-lg border shadow-sm"
          />
        )} */}
      </div>
    </div>
  </>
)}

        {/* {form.uploadedFile && (
          <div className="mt-3 w-3/4 flex items-center space-x-4 pt-5">
            <p
              className="border rounded-lg px-4 py-2 w-[50%] bg-blue-900 text-white cursor-pointer inline-block hover:bg-blue-700 transition duration-200"
              onClick={() => setShowPopup(true)}
            >
              Voir le document : {form.uploadedFile.filename}
            </p>
          </div>
        )}
        {showPopup && form.uploadedFile?.data && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40"
              onClick={closePopup}
            ></div>
            <div className="fixed w-[60%] h-[80%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white border shadow-lg rounded-lg z-50">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    Aperçu du fichier
                  </h3>
                  {form.uploadedFile.contentType?.startsWith("image/") && (
                    <div className="space-y-2">
                      <p className="text-sm text-gray-500 flex items-center gap-2">
                        Télécharger :
                        <a
                          href={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
                          download
                          className="p-1 rounded-full bg-gray-100 hover:bg-gray-200 transition"
                          title="Télécharger l'image"
                        >
                          <Download className="w-4 h-4 text-gray-700" />
                        </a>
                      </p>
                      <p className="text-sm text-gray-500">
                        Cliquez sur l’image pour l’agrandir
                      </p>
                    </div>
                  )}
                </div>
                <button
                  onClick={closePopup}
                  className="absolute top-2 right-4 ml-4 text-gray-500 hover:text-gray-700 font-bold text-xl transition"
                  aria-label="Fermer"
                >
                  X
                </button>
              </div>

              
              {form.uploadedFile.contentType?.startsWith("image/") && (
                <SlideshowLightbox className="mx-auto">
                  <img
                    src={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
                    alt="Aperçu"
                    className="max-w-full max-h-[500px] rounded-lg border cursor-zoom-in"
                  />
                </SlideshowLightbox>
              )}

              
              {form.uploadedFile.contentType === "application/pdf" && (
                <iframe
                  src={`data:application/pdf;base64,${form.uploadedFile.data}`}
                  title="PDF preview"
                  className="w-[100%] h-[90%] border mt-4"
                />
              )}
            </div>
          </>
        )} */}

        {form.dispositions && form.dispositions.length > 0 && (
          <div className="mt-8 pt-5">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Dispositions :
            </h3>

            <table className="w-full border border-gray-300 rounded-lg overflow-hidden table-fixed">
          <thead className="bg-gray-200">
            <tr>
              <th className="p-3 text-left font-medium w-1/4">Infraction</th>
              <th className="p-3 text-left font-medium w-1/6">Date</th>
              <th className="p-3 text-left font-medium w-1/4">Tribunal</th>
              <th className="p-3 text-left font-medium w-1/3">Commentaire</th>
            </tr>
          </thead>

          <tbody>
            {form.dispositions.map((d, i) => (
              <tr key={i} className="bg-white hover:bg-gray-50">
                <td className="border-t px-3 py-2 break-all whitespace-pre-wrap max-w-xs">
                  {d.infractions}
                </td>
                <td className="border-t px-3 py-2">
                  {d.date}
                </td>
                <td className="border-t px-3 py-2 break-all whitespace-pre-wrap max-w-xs">
                  {d.tribunal}
                </td>
                <td className="border-t px-3 py-2 break-all whitespace-pre-wrap max-w-sm">
                  {d.commentaire}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

          </div>
        )}

        {form.commentaire && (
          <p className="mt-4 text-lg text-gray-700">
            <strong
              className={
                form.etatDemande === "Approuvé"
                  ? "text-green-600"
                  : form.etatDemande === "Rejeté"
                    ? "text-red-600"
                    : "text-gray-600"
              }
            >
              Note du traiteur :
            </strong>{" "}
            {form.commentaire}
          </p>
        )}

        {form.traitant?.length > 0 && (
          <div className="mt-8 pt-5">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Traitants :
            </h3>
            <table className="w-full border border-gray-300 rounded-lg overflow-hidden ">
              <thead className="bg-gray-200">
                <tr>
                  <th className="p-3 text-left font-medium w-1/5">Nom</th>
                  <th className="p-3 text-left font-medium w-1/4">Email</th>
                  <th className="p-3 text-left font-medium w-1/6">État</th>
                  <th className="p-3 text-left font-medium w-1/4">
                    Date et heure
                  </th>
                  {form.nomFormulaire !==
                    "Réclamation mensuelle de dépenses" && (
                      <th className="p-3 text-left font-medium w-1/6">Notes</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {
                  // form.traitant.map((t, index) => (
                  form.traitant
                    ?.filter((t, index, arr) => {
                      // On cache la ligne "Enregistrer"
                      if (
                        t.etatDemande === "Enregistrer" &&
                        arr[index + 1]?.etatDemande === "En traitement"
                      ) {
                        return false;
                      }

                      // On cache la ligne "En traitement" qui suit "Enregistrer"
                      if (
                        t.etatDemande === "En traitement" &&
                        arr[index - 1]?.etatDemande === "Enregistrer"
                      ) {
                        return false;
                      }

                      return true;
                    })
                    .map((t, index) => (
                      <tr key={index} className={`bg-white `}>
                        <td className="border-t px-3 py-2 break-words">{t.nom}</td>
                        <td className="border-t px-3 py-2 break-words">
                          {t.email}
                        </td>
                        <td className="border-t px-3 py-2">{t.etatDemande}</td>
                        <td className="border-t px-3 py-2">
                          {formatDate(t.dateHeure)}
                        </td>
                        {form.nomFormulaire !==
                          "Réclamation mensuelle de dépenses" && (
                            <td className="border-t px-3 py-2 max-w-xs break-words whitespace-pre-wrap overflow-y-auto">{t.commentaire}</td>
                          )}

                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );

  function formatDate(dateInput) {
    try {
      if (!dateInput) return "Date invalide";

      // Si c'est déjà un objet Date valide
      if (dateInput instanceof Date && !isNaN(dateInput)) {
        return dateInput.toLocaleString("fr-CA", {
          dateStyle: "short",
          timeStyle: "short",
        });
      }

      // Sinon, on tente avec le constructeur Date
      const parsed = new Date(dateInput);

      // Si le constructeur ne fonctionne pas, on essaie avec Date.parse()
      if (isNaN(parsed)) {
        const timestamp = Date.parse(dateInput);
        if (!isNaN(timestamp)) {
          return new Date(timestamp).toLocaleString("fr-CA", {
            dateStyle: "short",
            timeStyle: "short",
          });
        } else {
          return "Date invalide";
        }
      }

      return parsed.toLocaleString("fr-CA", {
        dateStyle: "short",
        timeStyle: "short",
      });
    } catch (e) {
      return "Date invalide";
    }
  }
  const getStatusDotColor = (etat) => {
    switch (etat) {
      case "En attente":
        return "bg-orange-500";
      case "Soumis":
      return "bg-blue-500";
      case "En traitement":
        return "bg-yellow-500";
      case "À traiter":
        return "bg-yellow-500";
      case "Rejeté":
        return "bg-red-500";
      case "Approuvé":
        return "bg-green-500";
      default:
        return "bg-gray-500";
    }
  };

  // const handleStatusChange = (event) => {
  //   setStatusFilter(event.target.value);
  // };
  const handleLieuChange = (event) => {
    setLieuFilter(event.target.value);
  };
  
  const handleAssigneChange = (event) => {
    setAssigneFilter(event.target.value);
  };
  const handleNomFormulaire = (event) => {
    setNomFormulaire(event.target.value);
  };
  // Update filter value based on input
  const handleFilterChange = (event) => {
    setFilterValue(event.target.value);
  };

  // Update filter value based on input
  const handleFilterNom = (event) => {
    setFilterNom(event.target.value);
  };
  // const handleAcceptedByChange = (event) => {
  //   setAcceptedByFilter(event.target.value);
  //   setCurrentPage(1); // Réinitialiser à la première page
  // };

  const handleResetFilters = () => {
    setFilterValue(""); // Réinitialise le champ de numéro de formulaire
    setFilterNom("");
    // setStatusFilter(""); // Réinitialise le sélecteur de statut
    setLieuFilter("");
    setAssigneFilter("");
    setAcceptedByFilter(""); // Réinitialise le filtre "Accepté par"
    setStartDate(""); // Réinitialise la date "De"
    setEndDate(""); // Réinitialise la date "À"
    setNomFormulaire("");
    setCurrentPage(1);
  };



const [showFilters, setShowFilters] = useState(false);
const activeFiltersCount = [
  filterValue,
  filterNom,
  nomFormulaire,
  lieuFilter,
  assigneFilter,
  startDate,
  endDate,
].filter(Boolean).length;


  return (
    <div>
      {demandeEnAttente && (
        <div>
          {/* <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-200 transition-all duration-300">


  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">

    
    <div className="flex flex-col">
      <label htmlFor="filterValue" className="mb-1 text-md font-semibold text-gray-700">
        Numéro du formulaire
      </label>
      <input
        type="text"
        id="filterValue"
        placeholder="Entrez le numéro"
        value={filterValue}
        onChange={(e) => handleFilterChange(e)}
        className={`p-3 border rounded-xl shadow-sm focus:outline-none transition-all duration-200
          ${messageErreur ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-purple-500 focus:border-purple-500'}`}
      />
      {messageErreur && (
        <p className="mt-1 text-xs text-red-600 break-words">
          {messageErreur}
        </p>
      )}
    </div>

 
    <div className="flex flex-col">
      <label htmlFor="filterNom" className="mb-1 text-md font-semibold text-gray-700">
        Nom de la personne
      </label>
      <input
        type="text"
        id="filterNom"
        placeholder="Entrez le nom"
        value={filterNom}
        onChange={(e) => handleFilterNom(e)}
        className={`p-3 border rounded-xl shadow-sm focus:outline-none transition-all duration-200
          ${messageErreurNom ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-purple-500 focus:border-purple-500'}`}
      />
      {messageErreurNom && (
        <p className="mt-1 text-xs text-red-600 break-words">
          {messageErreurNom}
        </p>
      )}
    </div>

   
    <div className="flex flex-col">
      <label htmlFor="statusFilter" className="mb-1 text-md font-semibold text-gray-700">
        Statut
      </label>
      <select
        id="statusFilter"
        value={statusFilter}
        onChange={(e) => handleStatusChange(e)}
        className="p-3 border border-gray-300 rounded-xl shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      >
        <option value="">Tous les statuts</option>
        <option value="En attente">En attente</option>
        <option value="En traitement">En traitement</option>
        <option value="Rejeté">Rejeté</option>
        <option value="Approuvé">Approuvé</option>
        <option value="Soumis">Soumis</option>
      </select>
    </div>

    
    <div className="flex flex-col">
      <label htmlFor="nomFormulaire" className="mb-1 text-md font-semibold text-gray-700">
        Formulaire
      </label>
      <select
        id="nomFormulaire"
        value={nomFormulaire}
        onChange={(e) => handleNomFormulaire(e)}
        className="p-3 border border-gray-300 rounded-xl shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      >
        <option value="">Tous les formulaires</option>
        <option value="Accès hors pays">Accès hors pays</option>
        <option value="Accès au compte informatique">Accès au compte informatique</option>
        <option value="Achat équipement informatique">Achat équipement informatique</option>
        <option value="Antécédents criminels">Antécédents criminels</option>        
        <option value="Changement adresse">Changement d'adresse</option>
        <option value="Changement nom">Changement nom</option>
        <option value="Changement information bancaire">Changement information bancaire</option>        
        <option value="Demande AEFO">Demande AEFO</option>
        <option value="Demande FEESO">Demande FEESO</option>
        <option value="Demande SCFP">Demande SCFP</option>
        <option value="Réclamation mensuelle de dépenses">Réclamation mensuelle de dépenses</option>
      </select>
    </div>

   
    {(checkGroupSeancePlacement || checkGroupAdmin) && (
      <div className="flex flex-col">
        <label htmlFor="lieuFilter" className="mb-1 text-md font-semibold text-gray-700">
          Lieu de travail
        </label>
        <select
          id="lieuFilter"
          value={lieuFilter}
          onChange={(e) => handleLieuChange(e)}
          className="p-3 border border-gray-300 rounded-xl shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
        >
          <option value="">Tous les lieux</option>
          {excelDataEcole.map((row, i) => (
            <option key={`${row.École}-${i}`} value={row.École}>
              {row.École}
            </option>
          ))}
        </select>
      </div>
    )}

   
    {(checkGroupSeancePlacement || checkGroupAdmin) && (
      <div className="flex flex-col">
        <label htmlFor="assigneFilter" className="mb-1 text-md font-semibold text-gray-700">
          Assigné à
        </label>
        <select
          id="assigneFilter"
          value={assigneFilter}
          onChange={(e) => handleAssigneChange(e)}
          className="p-3 border border-gray-300 rounded-xl shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
        >
          <option value="">Tous</option>
          {listSpUsers.map((row) => (
            <option key={row._id} value={row.userId}>
              {row.nom}
            </option>
          ))}
        </select>
      </div>
    )}

   
    <div className="flex flex-col">
      <label htmlFor="startDate" className="mb-1 text-md font-semibold text-gray-700">
        De
      </label>
      <input
        type="date"
        id="startDate"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        className={`p-3 border rounded-xl shadow-sm focus:outline-none transition-all duration-200
          ${messageErreurDate ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-purple-500 focus:border-purple-500'}`}
      />
      {messageErreurDate && (
        <p className="mt-1 text-xs text-red-600 break-words">
          {messageErreurDate}
        </p>
      )}
    </div>

    <div className="flex flex-col">
      <label htmlFor="endDate" className="mb-1 text-md font-semibold text-gray-700">
        À
      </label>
      <input
        type="date"
        id="endDate"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      />
    </div>

  </div>

  
  <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-end">
    <button
      onClick={() => {
        setAuthLoading(true);
        setShouldFetch(true);
      }}
      className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white font-semibold px-3 py-3 rounded-xl shadow-md transition-all duration-200"
    >
      Rechercher
    </button>

    <button
      onClick={(e) => {
        setAuthLoading(true);
        handleResetFilters(e);
        setShouldFetch(true);
      }}
      className="w-full sm:w-auto bg-blue-500 hover:bg-blue-600 text-white font-semibold px-3 py-3 rounded-xl shadow-md transition-all duration-200"
    >
      Réinitialiser
    </button>
  </div>
</div> */}

<div className="flex items-center justify-between mb-5">
  <div className="flex items-center gap-3">

    <button
      onClick={() => setShowFilters((prev) => !prev)}
      className={`
        group relative inline-flex items-center gap-3 rounded-2xl px-4 py-2.5
        text-[14px] font-semibold transition-all duration-200
        focus:outline-none
        ${showFilters
          ? "bg-blue-500 text-white shadow-lg shadow-md"
          : "bg-white  border  border-blue-400 text-blue-600 shadow-md"}
      `}
    >

      {/* 🔥 Glow subtle */}
      <span className={`
        absolute inset-0 rounded-2xl transition-opacity duration-300
        ${showFilters ? "opacity-100 bg-blue-500/10" : "opacity-0 group-hover:opacity-100"}
      `}></span>

      {/* ICON */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`w-5 h-5 transition-colors ${
          showFilters ? "text-white" : "text-slate-500 group-hover:text-blue-600"
        }`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z"
        />
      </svg>

      {/* TEXT */}
      <span className="relative z-10">
        {showFilters ? "Fermer les filtres" : "Filtres"}
      </span>

      {/* BADGE */}
      {activeFiltersCount > 0 && (
        <span className={`
          relative z-10 inline-flex items-center justify-center
          min-w-[20px] h-[20px] text-xs font-bold rounded-full
          ${showFilters
            ? "bg-white text-blue-600"
            : "bg-blue-600 text-white"}
        `}>
          {activeFiltersCount}
        </span>
      )}

      {/* CHEVRON */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`w-4 h-4 relative z-10 transition-transform duration-300 ${
          showFilters ? "rotate-180 text-white" : "text-slate-400 group-hover:text-blue-600"
        }`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>

    </button>

    <p className="hidden md:block text-[14px] text-slate-500">
      Filtrer les demandes rapidement
    </p>

  </div>
</div>

{/* Panel filtres */}
{showFilters && (
  <div className="mb-6 overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_10px_30px_rgba(15,23,42,0.06)]">
    {/* Header */}
    <div className="border-b border-slate-100 bg-slate-50/70 px-6 py-4">
      
      <p className="mt-1 text-[14px] text-slate-500">
        Utilisez un ou plusieurs critères pour retrouver une demande plus rapidement.
      </p>
    </div>

    {/* Body */}
    <div className="p-6">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">

        {/* Numéro du formulaire */}
        <div className="flex flex-col">
          <label htmlFor="filterValue" className="mb-1.5 text-[14px] font-semibold text-slate-700">
            Numéro du formulaire
          </label>
          <input
            type="text"
            id="filterValue"
            placeholder="Entrez le numéro"
            value={filterValue}
            onChange={(e) => handleFilterChange(e)}
            className={`h-12 rounded-xl border bg-white px-3 text-[14px] text-slate-800 placeholder:text-slate-400 outline-none transition-all duration-200
              ${messageErreur
                ? "border-red-300 focus:ring-4 focus:ring-red-100"
                : "border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"}`}
          />
          {messageErreur && (
            <p className="mt-1.5 text-[14px] text-red-500">{messageErreur}</p>
          )}
        </div>

        {/* Nom */}
        <div className="flex flex-col">
          <label htmlFor="filterNom" className="mb-1.5 text-[14px] font-semibold text-slate-700">
            Nom de la personne
          </label>
          <input
            type="text"
            id="filterNom"
            placeholder="Entrez le nom"
            value={filterNom}
            onChange={(e) => handleFilterNom(e)}
            className={`h-12 rounded-xl border bg-white px-3 text-[14px] text-slate-800 placeholder:text-slate-400 outline-none transition-all duration-200
              ${messageErreurNom
                ? "border-red-300 focus:ring-4 focus:ring-red-100"
                : "border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"}`}
          />
          {messageErreurNom && (
            <p className="mt-1.5 text-[14px] text-red-500">{messageErreurNom}</p>
          )}
        </div>

        {/* Formulaire */}
        <div className="flex flex-col">
          <label htmlFor="nomFormulaire" className="mb-1.5 text-[14px] font-semibold text-slate-700">
            Formulaire
          </label>
          <select
            id="nomFormulaire"
            value={nomFormulaire}
            onChange={(e) => handleNomFormulaire(e)}
            className="h-12 rounded-xl border border-slate-200 bg-white px-3 text-[14px] text-slate-800 outline-none transition-all duration-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
          >
            <option value="">Tous les formulaires</option>
            <option value="Accès hors pays">Accès hors pays</option>
            <option value="Accès au compte informatique">Accès au compte informatique</option>
            <option value="Achat équipement informatique">Achat équipement informatique</option>
            <option value="Antécédents criminels">Antécédents criminels</option>
            <option value="Changement adresse">Changement d'adresse</option>
            <option value="Changement nom">Changement nom</option>
            <option value="Changement information bancaire">Changement information bancaire</option>
            <option value="Demande AEFO">Demande AEFO</option>
            <option value="Demande FEESO">Demande FEESO</option>
            <option value="Demande SCFP">Demande SCFP</option>
            <option value="Demande de projet">Demande de projet</option>
            <option value="Réclamation mensuelle de dépenses">Réclamation mensuelle de dépenses</option>
          </select>
        </div>

        {/* Lieu */}
        {(checkGroupSeancePlacement || checkGroupAdmin) && (
          <div className="flex flex-col">
            <label htmlFor="lieuFilter" className="mb-1.5 text-[14px] font-semibold text-slate-700">
              Lieu de travail
            </label>
            <select
              id="lieuFilter"
              value={lieuFilter}
              onChange={(e) => handleLieuChange(e)}
              className="h-12 rounded-xl border border-slate-200 bg-white px-3 text-[14px] text-slate-800 outline-none transition-all duration-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
            >
              <option value="">Tous les lieux</option>
              {excelDataEcole.map((row, i) => (
                <option key={`${row.École}-${i}`} value={row.École}>
                  {row.École}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Assigné à */}
        {(checkGroupSeancePlacement || checkGroupAdmin) && (
          <div className="flex flex-col">
            <label htmlFor="assigneFilter" className="mb-1.5 text-[14px] font-semibold text-slate-700">
              Assigné à
            </label>
            <select
              id="assigneFilter"
              value={assigneFilter}
              onChange={(e) => handleAssigneChange(e)}
              className="h-12 rounded-xl border border-slate-200 bg-white px-3 text-[14px] text-slate-800 outline-none transition-all duration-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
            >
              <option value="">Tous</option>
              {listSpUsers.map((row) => (
                <option key={row._id} value={row.userId}>
                  {row.nom}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Période */}
        <div className="sm:col-span-2 xl:col-span-2">
          <label className="mb-1.5 block text-[14px] font-semibold text-slate-700">
            Période
          </label>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="flex flex-col">
              <input
                type="date"
                id="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={`h-12 rounded-xl border bg-white px-3 text-[14px] text-slate-800 outline-none transition-all duration-200
                  ${messageErreurDate
                    ? "border-red-300 focus:ring-4 focus:ring-red-100"
                    : "border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"}`}
              />
              {messageErreurDate && (
                <p className="mt-1.5 text-[14px] text-red-500">{messageErreurDate}</p>
              )}
            </div>

            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="h-12 rounded-xl border border-slate-200 bg-white px-3 text-[14px] text-slate-800 outline-none transition-all duration-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
            />
          </div>
        </div>
      </div>

      {/* Footer actions */}
      <div className="mt-6 flex flex-col-reverse gap-3 border-t border-gray-100 pt-5 sm:flex-row sm:items-center sm:justify-start">
        <div className="flex items-center gap-3 justify-start">
          <button
            onClick={(e) => {
              setAuthLoading(true);
              handleResetFilters(e);
              setShouldFetch(true);
            }}
            className="h-12 rounded-xl bg-gray-100 px-3 text-[14px] font-medium text-gray-700 transition-all duration-200 hover:bg-gray-200"
          >
            Réinitialiser
          </button>

          <button
            onClick={() => {
              setAuthLoading(true);
              setShouldFetch(true);
            }}
            className="h-12 rounded-xl bg-[#2f5f98] px-3 text-[14px] font-semibold text-white shadow-sm transition-all duration-200 hover:bg-[#264d7d]"
          >
            Rechercher
          </button>
        </div>
      </div>
    </div>
  </div>
)}

          {/* <h2 className="text-2xl font-bold mb-2 text-gray-800 mt-8">
            Liste des Demandes
          </h2>
          <div className="flex items-start gap-3 bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-6">
           
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-500 mt-0.5 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
              />
            </svg>

            <p className="text-gray-700 text-base">
              Les données affichées dans le tableau correspondent aux{" "}
              <strong>deux derniers mois</strong>. Pour consulter des données
              plus anciennes, veuillez utiliser le filtrage et sélectionner
              l’intervalle de dates souhaité.
            </p>
          </div>
          <div className="overflow-x-auto shadow-md rounded-lg">
            <table className="min-w-full table-fixed">
              <thead className="bg-gray-100 border-b">
                <tr className="text-gray-700 font-medium">

                  <th className="px-4 py-3 text-left">Nom du formulaire</th>
                  <th className="px-4 py-3 text-left">Numéro de formulaire</th>
                  <th className="px-4 py-3 text-left">Demandeur</th>

                  
                  <th
                    onClick={() => handleSort("submissionDate")}
                    className={`px-4 py-3 text-left cursor-pointer transition-colors
                   hover:text-blue-600
                         ${sortConfig.key === "submissionDate" ? "text-blue-600" : ""}
                            `}
                  >
                    Date de soumission
                    {sortConfig.key === "submissionDate" && (
                      <span className="ml-2 text-sm">
                        {sortConfig.order === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </th>

                  <th className="px-4 py-3 text-left">Statut</th>

                  {(checkGroupRecMensuelle || checkGroupAdmin) && (
                    <th
                      onClick={() => handleSort("processingDate")}
                      className={`px-4 py-3 text-left cursor-pointer transition-colors
              hover:text-blue-600
              ${sortConfig.key === "processingDate" ? "text-blue-600" : ""}
            `}
                    >
                      Date d’attribution
                      {sortConfig.key === "processingDate" && (
                        <span className="ml-2 text-sm">
                          {sortConfig.order === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </th>
                  )}

                  {(checkGroupSeancePlacement || checkGroupAdmin) && (
                    <th className="px-4 py-3 text-left">Lieu de travail</th>
                  )}



                  <th className="px-4 py-3 text-left">Assignée</th>

                </tr>
              </thead>

              <tbody>
                {authLoading ? (
                  <tr>
                    <td colSpan="6" className="py-6 text-center">
                      <div className="flex items-center justify-center">
                        <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                        <p className="ml-3 text-gray-700 font-medium">
                          Chargement en cours...
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  currentData // Filtrer les demandes en attente
                    .map((form, index) => (
                      <tr
                        key={form._id}
                        // className="border-b hover:bg-gray-50"
                        className="border-b bg-white hover:bg-blue-50 hover:shadow-lg hover:scale-[1.00] transition-transform transition-shadow duration-300 ease-in-out cursor-pointer"
                        onClick={() => handleRowClick(form)}
                      >
                        <td className="px-4 py-3">
                          {form.nomFormulaire}
                          {form.periodReclamation && (
                            <>
                              {" "}
                              -{" "}
                              {new Intl.DateTimeFormat("fr-CA", {
                                year: "numeric",
                                month: "long",
                                timeZone: "UTC",
                              }).format(new Date(form.periodReclamation))}
                            </>
                          )}
                        </td>
                        <td className="px-4 py-3">{form.numeroFormulaire}</td>
                        <td className="px-4 py-3">{form.nom}</td>

                        <td className="px-4 py-3">
                          {new Date(form.dateSoumission).toLocaleString("fr-FR", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                        </td>
                        <td className="px-4 py-3">
                          <span
                            className={`inline-block w-3 h-3 rounded-full mr-2 ${getStatusDotColor(
                              form.etatDemande
                            )}`}
                          ></span>{" "}
                          {form.etatDemande}
                        </td>
                        {checkGroupRecMensuelle || checkGroupAdmin ?
                          <td className="px-4 py-3">
                            {new Date(form.traitant[form.traitant.length - 1]?.dateHeure).toLocaleString("fr-FR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })}

                          </td> : ""}

                        {(checkGroupSeancePlacement || checkGroupAdmin) && (
                          <td className="px-4 py-3">{form.lieuTravail}</td>
                        )}

                        <td className="px-4 py-3">
                          <span className="text-blue-800">
                            {form.nomFormulaire ===
                              "Réclamation mensuelle de dépenses" &&
                              form.managerInfo.etatDemande === "Approuvé" &&
                              recMensuelleGroupUserIds.includes(
                                form.traitant[form.traitant.length - 1]?.userId
                              )
                              ? // (checkGroupRecMensuelle || checkGroupAdmin)
                              "Comptes Payables : "
                              : ""}
                          </span>
                          <span>
                            {form.traitant.length > 0 &&
                              form.etatDemande !== "En attente"
                              ? form.traitant[form.traitant.length - 1].nom
                              : "—"}
                          </span>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>

            {demandeEnAttente.length > 0 && (
              <div className="mt-4 flex justify-center items-center space-x-4">
                <button
                  onClick={() => { window.scrollTo({ top: 230, behavior: "smooth" }); handlePageChange(currentPage - 1) }}
                  className="px-4 py-2 rounded-md bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={currentPage === 1}
                >
                  Précédent
                </button>

                <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-800 font-medium">
                  {currentPage} sur {totalPages}
                </span>

                <button
                  onClick={() => { handlePageChange(currentPage + 1); window.scrollTo({ top: 230, behavior: "smooth" }); }}
                  className="px-4 py-2 rounded-md bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={currentPage === totalPages}
                >
                  Suivant
                </button>
              </div>)}
          </div> */}

 <div className="mt-8 mb-6 flex items-center justify-between">

  <div>
    {/* TITLE + BADGE */}
    <div className="flex items-center gap-3">
      <h2 className="text-2xl font-semibold text-slate-900 tracking-tight">
        Liste des demandes
      </h2>

      <span className="
        inline-flex items-center gap-1.5
        text-sm font-semibold
        bg-blue-50 text-blue-700
        px-3 py-1 rounded-full
        border border-blue-100
      ">
        {sortedDemandes.length}
        <span className="text-slate-500 font-medium">demandes</span>
      </span>
    </div>

    {/* SUBTEXT */}
    <p className="text-sm text-slate-500 mt-1.5">
      Consultez et gérez les demandes en un seul endroit
    </p>
  </div>

</div>
          {/* Onglets par statut */}

<div className="flex gap-1.5 border-b border-gray-200 mb-6 overflow-x-auto">
  {tabs.map((tab) => {
    const count =
  tab.label === "À traiter"
    ? demandeEnAttente.filter(
        (f) =>
          f.etatDemande === "En attente" ||
          f.etatDemande === "En traitement"
      ).length
    : demandeEnAttente.filter(
        (f) => f.etatDemande === tab.label
      ).length;

    const isActive = activeTab === tab.label;
    const hasCount = count > 0;

    return (
      <button
        key={tab.label}
        onClick={() => {
          setActiveTab(tab.label);
          handlePageChange(1);
        }}
        className={`relative flex items-center gap-2 px-4 py-3 text-[15px] font-medium border-b-2 whitespace-nowrap transition-all duration-200
          ${
            isActive
              ? "border-blue-500 text-blue-600"
              : hasCount
              ? "border-transparent text-gray-700 hover:text-gray-900"
              : "border-transparent text-gray-400 hover:text-gray-500"
          }`}
      >
        <span
          className={`w-2.5 h-2.5 rounded-full ${getStatusDotColor(tab.label)} ${
            hasCount ? "opacity-100" : "opacity-45"
          }`}
        ></span>

        <span className={`${isActive ? "font-semibold" : hasCount ? "font-medium" : "font-normal"}`}>
          {tab.label}
        </span>

        <span
          className={`ml-1 text-[11px] font-semibold px-2.5 py-0.5 rounded-full transition-all duration-200
            ${
               hasCount
                ? `${getTabBadgeColor(tab.label)}`
                : "bg-gray-100 text-gray-400"
            }`}
        >
          {count}
        </span>
      </button>
    );
  })}
</div>

{activeTab !== "À traiter" && (
  <div className="mb-6 mt-4 flex items-center gap-3 rounded-xl border border-blue-100 bg-blue-50/60 px-4 py-2.5 text-[14px] text-blue-800">
    
    {/* Petite icône info */}
    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-blue-600 text-xs font-bold">
      i
    </div>

    {/* Texte */}
    <p className="leading-relaxed">
      Les demandes affichées correspondent aux <span className="font-semibold">30 derniers jours</span>.  
      Si vous souhaitez voir plus de demandes, utilisez les <span className="font-semibold">filtres</span>.
    </p>

  </div>
)}
          

          <div className="overflow-x-auto shadow-md rounded-lg">
           <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm">
  <table className="min-w-full table-fixed">

    {/* HEADER */}
    <thead className="bg-slate-100 border-b border-slate-200">
      <tr className="text-slate-700 font-semibold text-[15px]">

        <th className="px-6 py-4 text-left">Nom du formulaire</th>
        <th className="px-6 py-4 text-left">Numéro de formulaire</th>
        <th className="px-6 py-4 text-left">Demandeur</th>

        {/* Date de soumission */}
        <th
          onClick={() => handleSort("submissionDate")}
          className={`px-6 py-4 text-left cursor-pointer transition
            hover:text-blue-600 hover:bg-blue-50
            ${sortConfig.key === "submissionDate" ? "text-blue-600 bg-blue-50" : ""}
          `}
        >
          <div className="inline-flex items-center gap-2">
            <span>Date de soumission</span>
            {sortConfig.key === "submissionDate" && (
              <span className="text-sm font-bold">
                {sortConfig.order === "asc" ? "▲" : "▼"}
              </span>
            )}
          </div>
        </th>

        {(checkGroupRecMensuelle || checkGroupAdmin) && (
          <th
            onClick={() => handleSort("processingDate")}
            className={`px-6 py-4 text-left cursor-pointer transition
              hover:text-blue-600 hover:bg-blue-50
              ${sortConfig.key === "processingDate" ? "text-blue-600 bg-blue-50" : ""}
            `}
          >
            <div className="inline-flex items-center gap-2">
              <span>Date d’attribution</span>
              {sortConfig.key === "processingDate" && (
                <span className="text-sm font-bold">
                  {sortConfig.order === "asc" ? "▲" : "▼"}
                </span>
              )}
            </div>
          </th>
        )}

        {(checkGroupSeancePlacement || checkGroupAdmin) && (
          <th className="px-6 py-4 text-left">Lieu de travail</th>
        )}

        <th className="px-6 py-4 text-left">Statut</th>
        <th className="px-6 py-4 text-left">Assignée</th>
      </tr>
    </thead>

    {/* BODY */}
    <tbody className="divide-y divide-slate-100">
      {authLoading ? (
        <tr>
          <td colSpan="6" className="py-8 text-center">
            <div className="flex items-center justify-center">
              <div className="w-6 h-6 border-4 border-slate-300 border-t-blue-500 rounded-full animate-spin"></div>
              <p className="ml-3 text-slate-700 font-medium text-[15px]">
                Chargement en cours...
              </p>
            </div>
          </td>
        </tr>
      ) : (
        currentData.map((form, index) => (
          <tr
            key={form._id}
            className="bg-white hover:bg-slate-50 transition duration-200 cursor-pointer"
            onClick={() => handleRowClick(form)}
          >
            {/* NOM */}
            <td className="px-6 py-5 text-[15px] text-slate-900 font-semibold">
              <div className="leading-6">
                <span>{form.nomFormulaire}</span>
                {form.periodReclamation && (
                  <span className="text-slate-500 font-normal">
                    {" "}
                    -{" "}
                    {new Intl.DateTimeFormat("fr-CA", {
                      year: "numeric",
                      month: "long",
                      timeZone: "UTC",
                    }).format(new Date(form.periodReclamation))}
                  </span>
                )}
              </div>
            </td>

            {/* NUMERO */}
            <td className="px-6 py-5 text-[14px]">
              <span className="bg-slate-100 px-2.5 py-1 rounded-md font-mono text-slate-700">
                {form.numeroFormulaire}
              </span>
            </td>

            {/* DEMANDEUR */}
            <td className="px-6 py-5 text-[15px] text-slate-800">
              {form.nom}
            </td>

            {/* DATE */}
            <td className="px-6 py-5 text-[14px] text-slate-600">
              {new Date(form.dateSoumission).toLocaleString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
            </td>

            {/* ATTRIBUTION */}
            {checkGroupRecMensuelle || checkGroupAdmin ? (
              <td className="px-6 py-5 text-[14px] text-slate-600">
                {new Date(
                  form.traitant[form.traitant.length - 1]?.dateHeure
                ).toLocaleString("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })}
              </td>
            ) : (
              ""
            )}

            {/* LIEU */}
            {(checkGroupSeancePlacement || checkGroupAdmin) && (
              <td className="px-6 py-5 text-[15px] text-slate-700">
                {form.lieuTravail}
              </td>
            )}

            {/* STATUT */}
            <td className="px-6 py-5 text-[14px]">
              <div className="inline-flex items-center rounded-full bg-slate-50 px-3 py-1.5 border border-slate-200">
                <span
                  className={`inline-block w-2.5 h-2.5 rounded-full mr-2 ${getStatusDotColor(
                    form.etatDemande
                  )}`}
                ></span>
                <span className="font-medium text-slate-700">
                  {form.etatDemande}
                </span>
              </div>
            </td>

            {/* ASSIGNÉ */}
            <td className="px-6 py-5 text-[15px] text-slate-700">
              <span className="text-blue-700 font-medium">
                {form.nomFormulaire === "Réclamation mensuelle de dépenses" &&
                form.managerInfo.etatDemande === "Approuvé" &&
                recMensuelleGroupUserIds.includes(
                  form.traitant[form.traitant.length - 1]?.userId
                )
                  ? "Comptes Payables : "
                  : ""}
              </span>
              <span>
                {form.traitant.length > 0 && form.etatDemande !== "En attente"
                  ? form.traitant[form.traitant.length - 1].nom
                  : "—"}
              </span>
            </td>
          </tr>
        ))
      )}
    </tbody>

  </table>
</div>

            
            { currentData.length > 0 && (
              <div className="mt-4 flex justify-center items-center space-x-4">
                <button
                  onClick={() => { window.scrollTo({ top: 230, behavior: "smooth" }); handlePageChange(currentPage - 1) }}
                  className="px-4 py-2 rounded-md bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={currentPage === 1}
                >
                  Précédent
                </button>

                <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-800 font-medium">
                  {currentPage} sur {totalPages}
                </span>

                <button
                  onClick={() => { handlePageChange(currentPage + 1); window.scrollTo({ top: 230, behavior: "smooth" }); }}
                  className="px-4 py-2 rounded-md bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={currentPage === totalPages}
                >
                  Suivant
                </button>
              </div>)}
          
          </div>

          {/* Main Popup Modal */}

          {selectedForm && (
            <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-start z-50 pt-10">
              <div className="bg-white p-8 rounded-2xl shadow-2xl w-[65%] max-w-[1200px] max-h-[90vh] overflow-y-auto relative">
                {/* Bouton Fermer */}
                <button
                  onClick={closeModal}
                  aria-label="Fermer"
                  className="absolute top-5 right-5 text-gray-400 hover:text-gray-700 transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                {/* Titre */}
                <h2 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-2">
                  Détails de la Demande
                </h2>

                {/* Contenu principal */}
                <div className="space-y-4">
                  {renderFormDetails(selectedForm)}
                </div>

                {/* Commentaires */}
                {selectedForm.etatDemande === "En traitement" &&
                  selectedForm.nomFormulaire !==
                  "Réclamation mensuelle de dépenses" &&
                  selectedForm.nomFormulaire !==
                  "Demande AEFO" &&
                  selectedForm.nomFormulaire !==
                  "Demande FEESO" &&
                  selectedForm.nomFormulaire !==
                  "Demande SCFP" &&
                  selectedForm.nomFormulaire !==
                  "Achat équipement informatique" &&
                  selectedForm.nomFormulaire !==
                  "Accès hors pays"&&
                  (selectedForm.traitant.at(-1).userId === user.id ||
                    checkGroupAdmin) && (
                    <div className="mt-4 space-y-3">
                      <textarea
                        value={rejectComment}
                        onChange={(e) => {
                          setRejectComment(e.target.value);
                          if (e.target.value.trim()) setErrorMessage("");
                        }}
                        placeholder="Ajoutez un commentaire..."
                        rows={3}
                        className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-300 transition-all"
                      />
                      {errorMessage && (
                        <p className="text-red-500 text-sm">{errorMessage}</p>
                      )}

                      <div className="flex items-center space-x-3">
                        <label className="text-md font-medium text-blue-900">
                          Souhaitez-vous que le demandeur voie ce commentaire ?
                        </label>
                        <select
                          value={showComment}
                          onChange={(e) => {
                            setShowComment(e.target.value);
                            if (e.target.value.trim()) setErrorShowComment("");
                          }}
                          className="p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-300 transition-all"
                        >
                          <option value="">Sélectionner...</option>
                          <option value="oui">Oui</option>
                          <option value="non">Non</option>
                        </select>
                      </div>
                      {errorShowComment && (
                        <p className="text-red-500 text-sm">
                          {errorShowComment}
                        </p>
                      )}
                    </div>
                  )}

                {/* Actions principales */}
                <div className="mt-6 flex flex-wrap gap-4 justify-end items-center">
                  {/* En traitement */}
                  {selectedForm.etatDemande === "En traitement" &&
                    selectedForm.nomFormulaire &&
                    selectedForm.nomFormulaire !==
                    "Réclamation mensuelle de dépenses" &&
                    selectedForm.nomFormulaire !==
                    "Demande AEFO" &&
                    selectedForm.nomFormulaire !==
                    "Demande FEESO" &&
                    selectedForm.nomFormulaire !==
                    "Demande SCFP" &&
                    selectedForm.nomFormulaire !==
                    "Achat équipement informatique" &&
                    selectedForm.nomFormulaire !==
                    "Accès hors pays" &&
                    !showReject &&
                    !showConfirm &&
                    (selectedForm.traitant.at(-1).userId === user.id ||
                      checkGroupAdmin) && (
                      <>
                        <button
                          className="px-6 py-2 bg-red-600 text-white rounded-xl shadow hover:bg-red-700 transition-all"
                          onClick={() => setshowReject(true)}
                        >
                          Rejeter
                        </button>
                        <button
                          className="px-6 py-2 bg-yellow-600 text-white rounded-xl shadow hover:bg-yellow-700 transition-all"
                          onClick={handleReassignClick}
                        >
                          Réassigner
                        </button>
                        <button
                          className="px-6 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition-all"
                          onClick={() => setshowConfirm(true)}
                        >
                          Approuver
                        </button>
                      </>
                    )}

                  {/* En attente */}
                  {selectedForm.etatDemande === "En attente" && (
                    <button
                      onClick={() =>
                        changeRequest(
                          selectedForm._id,
                          selectedForm.nomFormulaire,
                          "En traitement",
                          selectedForm.courriel,
                          selectedForm.numeroFormulaire
                        )
                      }
                      className="px-6 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition-all"
                    >
                      Prendre en charge
                    </button>
                  )}

                  {(selectedForm.nomFormulaire === "Demande de projet") && 
                  (!selectedForm.estFerme) && 
                  (
                      <button
                        onClick={() => handleCloturerClick(selectedForm._id)}
                        className="px-6 py-2 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition-all"
                      >
                        Clôturer la demande
                      </button>
                  )}

                  {/* Réclamation mensuelle */}
                  {(selectedForm.nomFormulaire ===
                    "Réclamation mensuelle de dépenses" || selectedForm.nomFormulaire ===
                    "Demande AEFO" || selectedForm.nomFormulaire ===
                    "Demande FEESO" || selectedForm.nomFormulaire ===
                    "Demande SCFP" || selectedForm.nomFormulaire ===
                    "Achat équipement informatique" || selectedForm.nomFormulaire ===
                    "Accès hors pays" || selectedForm.nomFormulaire ===
                    "Demande de projet") && selectedForm.etatDemande !== "En attente" && (
                      <button
                        onClick={() => handleContinueClick(true)}
                        className="px-6 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition-all"
                      >
                        Consulter
                      </button>
                    )}
                  
                  {/* Fermer */}
                  {!showReject && !showConfirm && (
                    <button
                      onClick={closeModal}
                      className="px-6 py-2 bg-gray-200 text-gray-700 rounded-xl shadow hover:bg-gray-300 transition-all"
                    >
                      Fermer
                    </button>
                  )}
                </div>

                {/* Confirmation Rejet */}
                {showReject && (
                  <div className="mt-6 border-t pt-4 space-y-3">
                    <h3 className="text-xl font-semibold">
                      Confirmation du Rejet
                    </h3>
                    <div className="flex justify-end gap-3">
                      <button
                        onClick={() => {
                          setshowReject(false);
                          setRejectComment("");
                          setShowComment("");
                          setErrorMessage("");
                          setErrorShowComment("");
                        }}
                        className="px-4 py-2 bg-gray-300 text-black rounded-xl shadow hover:bg-gray-400 transition-all"
                      >
                        Annuler
                      </button>
                      <button
                        onClick={() => {
                          changeRequest(
                            selectedForm._id,
                            selectedForm.nomFormulaire,
                            "Rejeté",
                            selectedForm.courriel,
                            selectedForm.numeroFormulaire
                          );
                          setshowReject(false);
                        }}
                        className="px-4 py-2 bg-red-500 text-white rounded-xl shadow hover:bg-red-600 transition-all"
                      >
                        Soumettre
                      </button>
                    </div>
                  </div>
                )}

                {/* Confirmation Approve */}
                {showConfirm && (
                  <div className="mt-6 border-t pt-4 space-y-3">
                    <h3 className="text-xl font-semibold">
                      Confirmation de l’Approbation
                    </h3>
                    <div className="flex justify-end gap-3">
                      <button
                        onClick={() => setshowConfirm(false)}
                        className="px-4 py-2 bg-gray-300 text-black rounded-xl shadow hover:bg-gray-400 transition-all"
                      >
                        Annuler
                      </button>
                      <button
                        onClick={() => {
                          changeRequest(
                            selectedForm._id,
                            selectedForm.nomFormulaire,
                            "Approuvé",
                            selectedForm.courriel,
                            selectedForm.numeroFormulaire
                          );
                          setshowConfirm(false);
                        }}
                        className="px-4 py-2 bg-green-500 text-white rounded-xl shadow hover:bg-green-600 transition-all"
                      >
                        Soumettre
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Popup pour Réassigner */}
          {showReassignPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-8 rounded-lg shadow-lg w-1/3">
                <h2 className="text-2xl font-bold mb-6 text-gray-800">
                  Réassigner la tâche
                </h2>
                <label className="block mb-2 text-sm font-medium text-gray-600">
                  Email:
                </label>
                {/* <UsersList onUserSelect={handleUserSelect}></UsersList> */}
                <ReassignerGroup
                  nomFormulaire={selectedForm.nomFormulaire}
                  onUserSelect={handleUserSelect}
                />
                {errorReassign && (
                  <p className="text-red-500 text-sm mb-4">{errorReassign}</p>
                )}
                <label className="block mt-4 mb-2 text-sm font-medium text-gray-600">
                  Nom:
                </label>
                <input
                  type="text"
                  value={nomUser}
                  disabled
                  className="w-1/2 p-3 border border-gray-300 rounded-lg text-gray-700 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400"
                  required
                />
                <div className="flex justify-end mt-6 space-x-4">
                  <button
                    className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                    onClick={handleReassignCancel}
                  >
                    Annuler
                  </button>
                  <button
                    className="px-5 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                    onClick={() =>
                      handleReassignConfirm(
                        selectedForm._id,
                        selectedForm.nomFormulaire
                      )
                    }
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          )}
          {isLoading && (
            <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
              <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
              <p className="ml-3 text-gray-700 font-medium">
                Chargement en cours...
              </p>
            </div>
          )}

          {isAccepted && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
              <div
                className={`flex items-center space-x-3 px-5 py-4 bg-white ${message.color} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
              >
                <CheckCircleIcon
                  className={`h-8 w-8 ${message.color} animate-pulse`}
                />
                <span className="text-lg font-semibold">{message.message}</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default TachesEnAttente;










  // const renderFormDetails = (form) => (
  //   <div className="space-y-6">
  //     <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
  //       <p>
  //         <strong>Formulaire:</strong> {form.nomFormulaire}
  //       </p>
  //       <p>
  //         <strong>Numéro de formulaire:</strong> {form.numeroFormulaire}
  //       </p>
  //       <p>
  //         <strong>Nom:</strong> {form.nom}
  //       </p>
  //       {form.courriel && (
  //         <p>
  //           <strong>Courriel: </strong> {form.courriel}
  //         </p>
  //       )}
  //       {form.poste && (
  //         <p>
  //           <strong>Poste: </strong> {form.poste}
  //         </p>
  //       )}
  //       {form.matricule && (
  //         <p>
  //           <strong>Matricule Centrale: </strong> {form.matricule}
  //         </p>
  //       )}

  //       <p>
  //         <strong>Date de soumission:</strong>{" "}
  //         {new Date(form.dateSoumission).toLocaleString("fr-FR", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           hour12: false,
  //         })}
  //       </p>
  //       <p>
  //         <strong>État de la demande:</strong> {form.etatDemande}
  //       </p>
  //       {form.pasReconnuCoupableDepuisDerniereDeclaration && (
  //         <p>
  //           <strong>Pas reconnu coupable depuis derniere declaration : </strong>{" "}
  //           {form.pasReconnuCoupableDepuisDerniereDeclaration}
  //         </p>
  //       )}
  //       {form.reconnuCoupableDepuisDerniereDeclaration && (
  //         <p>
  //           <strong>Reconnu coupable depuis derniere declaration : </strong>{" "}
  //           {form.reconnuCoupableDepuisDerniereDeclaration}
  //         </p>
  //       )}
  //       {form.declarationExacteEtComplete && (
  //         <p>
  //           <strong>Declaration exacte et complete : </strong>{" "}
  //           {form.declarationExacteEtComplete}
  //         </p>
  //       )}
  //       {form.dateDeclaration && (
  //         <p>
  //           <strong>Date de déclaration :</strong>{" "}
  //           {form.dateDeclaration.slice(0, 10)}
  //         </p>
  //       )}
  //       {form.dispositions && form.dispositions.length > 0 && (
  //         <div>
  //           <strong>Dispositions :</strong>
  //           {form.dispositions.map((disposition, index) => (
  //             <div key={index} style={{ marginLeft: "20px", marginTop: "5px" }}>
  //               <p>
  //                 <strong>Infractions :</strong> {disposition.infractions}
  //               </p>
  //               <p>
  //                 <strong>Date :</strong> {disposition.date}
  //               </p>
  //               <p>
  //                 <strong>Tribunal :</strong> {disposition.tribunal}
  //               </p>
  //               <p>
  //                 <strong>Commentaire :</strong> {disposition.commentaire}
  //               </p>
  //             </div>
  //           ))}
  //         </div>
  //       )}

  //       {form.nomMembre && (
  //         <p>
  //           <strong>Nom du membre du personnel: </strong> {form.nomMembre}
  //         </p>
  //       )}
  //       {form.prenomMembre && (
  //         <p>
  //           <strong>Prénom du membre du personnel: </strong> {form.prenomMembre}
  //         </p>
  //       )}
  //       {form.posteMembre && (
  //         <p>
  //           <strong>Poste du membre du personnel: </strong> {form.posteMembre}
  //         </p>
  //       )}
  //       {form.lieuTravail && (
  //         <p>
  //           <strong>Lieu de travail: </strong> {form.lieuTravail}
  //         </p>
  //       )}
  //       {form.adressePostalResidentielle === "non" && (
  //         <p className="mt-3 block text-md font-medium text-blue-900">
  //           <strong>Adresse Résidentielle </strong>
  //         </p>
  //       )}
  //       {form.adresse && (
  //         <p>
  //           <strong>Adresse: </strong> {form.adresse}
  //         </p>
  //       )}
  //       {form.numeroappartement && (
  //         <p>
  //           <strong>Appartement: </strong> {form.numeroappartement}
  //         </p>
  //       )}
  //       {form.ville && (
  //         <p>
  //           <strong>Ville: </strong> {form.ville}
  //         </p>
  //       )}
  //       {form.province && (
  //         <p>
  //           <strong>Province: </strong> {form.province}
  //         </p>
  //       )}
  //       {form.codePostal && (
  //         <p>
  //           <strong>Code postal: </strong> {form.codePostal}
  //         </p>
  //       )}
  //       {form.adressePostalResidentielle === "non" && (
  //         <p className="mt-3 block text-md font-medium text-blue-900">
  //           <strong>Adresse Postale </strong>
  //         </p>
  //       )}

  //       {form.adressePostalResidentielle === "non" && form.boitePostale && (
  //         <p>
  //           <strong>Boite Postale: </strong> {form.boitePostale}
  //         </p>
  //       )}

  //       {form.adressePostalResidentielle === "non" &&
  //         form.appartementPostale && (
  //           <p>
  //             <strong>Appartement / unité : </strong> {form.appartementPostale}
  //           </p>
  //         )}

  //       {form.adressePostalResidentielle === "non" && form.villePostale && (
  //         <p>
  //           <strong>Ville: </strong> {form.villePostale}
  //         </p>
  //       )}
  //       {form.adressePostalResidentielle === "non" && form.provincePostale && (
  //         <p>
  //           <strong>Province: </strong> {form.provincePostale}
  //         </p>
  //       )}
  //       {form.adressePostalResidentielle === "non" &&
  //         form.codePostalPostale && (
  //           <p>
  //             <strong>Code Postal: </strong> {form.codePostalPostale}
  //           </p>
  //         )}

  //       {form.telephone && (
  //         <p className="mt-3">
  //           <strong>Numéro de téléphone principal: </strong>{" "}
  //           {`${form.telephone.slice(0, 3)} ${form.telephone.slice(
  //             3,
  //             6
  //           )} ${form.telephone.slice(6, 10)}`}
  //         </p>
  //       )}

  //       {form.telephoneCellulaire && (
  //         <p>
  //           <strong>Autre numéro de téléphone (optionnel): </strong>{" "}
  //           {`${form.telephoneCellulaire.slice(
  //             0,
  //             3
  //           )} ${form.telephoneCellulaire.slice(
  //             3,
  //             6
  //           )} ${form.telephoneCellulaire.slice(6, 10)}`}
  //         </p>
  //       )}
  //       {form.dateEntreeEnVigueur && (
  //         <p>
  //           <strong>Date d'entree en vigueur: </strong>{" "}
  //           {form.dateEntreeEnVigueur}
  //         </p>
  //       )}
  //       {form.dateDebut && (
  //         <p>
  //           <strong>Date de début: </strong> {form.dateDebut}
  //         </p>
  //       )}
  //       {form.dateFin && (
  //         <p>
  //           <strong>Date de fin: </strong> {form.dateFin}
  //         </p>
  //       )}
  //       {form.courrielSuperviseur && (
  //         <p>
  //           <strong>Courriel du superviseur: </strong>{" "}
  //           {form.courrielSuperviseur}
  //         </p>
  //       )}
  //       {form.commentairesDemandeur && (
  //         <p>
  //           <strong>Commentaires du demandeur: </strong>{" "}
  //           {form.commentairesDemandeur}
  //         </p>
  //       )}
  //       {form.nouveauNom && (
  //         <p>
  //           <strong>Nouveau Nom : </strong> {form.nouveauNom}
  //         </p>
  //       )}
  //       {form.nouveauPrenom && (
  //         <p>
  //           <strong>Nouveau Prénom : </strong> {form.nouveauPrenom}
  //         </p>
  //       )}
  //       {form.deuxiemePrenom && (
  //         <p>
  //           <strong>Deuxième Prénom : </strong> {form.deuxiemePrenom}
  //         </p>
  //       )}
  //       {form.institution && (
  //         <p>
  //           <strong>Institution : </strong> {form.institution}
  //         </p>
  //       )}
  //       {form.banque && (
  //         <p>
  //           <strong>Banque : </strong> {form.banque}
  //         </p>
  //       )}
  //       {form.numeroTransit && (
  //         <p>
  //           <strong>Numéro de transit : </strong> {form.numeroTransit}
  //         </p>
  //       )}
  //       {form.numeroCompte && (
  //         <p>
  //           <strong>Numéro de compte : </strong> {form.numeroCompte}
  //         </p>
  //       )}
  //       {/* {form.commentaire && (
  //       <p>
  //         <strong>commentaire : </strong> {form.commentaire}
  //       </p>
  //     )} */}
  //       {form.periodReclamation && (
  //         <p>
  //           <strong>Période de la réclamation :</strong>{" "}
  //           {new Intl.DateTimeFormat("fr-CA", {
  //             year: "numeric",
  //             month: "long",
  //             timeZone: "UTC", // <=== force UTC
  //           }).format(new Date(form.periodReclamation))}
  //         </p>
  //       )}

  //       {form.documentJustificatif && (
  //         <p>
  //           <strong>document justificatif : </strong>{" "}
  //           {form.documentJustificatif}
  //         </p>
  //       )}

  //       {form.uploadedFile && (
  //         <div className="mt-3 w-3/4 flex items-center space-x-4">
  //           <p
  //             className="border rounded-lg px-4 py-2 w-[50%] bg-blue-900 text-white cursor-pointer inline-block hover:bg-blue-700 transition duration-200"
  //             onClick={() => setShowPopup(true)}
  //           >
  //             Voir le document : {form.uploadedFile.filename}
  //           </p>
  //         </div>
  //       )}
  //       {showPopup && form.uploadedFile?.data && (
  //         <>
  //           <div
  //             className="fixed inset-0 bg-black bg-opacity-50 z-40"
  //             onClick={closePopup}
  //           ></div>
  //           <div className="fixed w-[60%] h-[80%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white border shadow-lg rounded-lg z-50">
  //             <div className="flex justify-between items-center">
  //               <div>
  //                 <h3 className="text-xl font-semibold text-gray-800 mb-2">
  //                   Aperçu du fichier
  //                 </h3>
  //                 {form.uploadedFile.contentType?.startsWith("image/") && (
  //                   <div className="space-y-2">
  //                     <p className="text-sm text-gray-500 flex items-center gap-2">
  //                       Télécharger :
  //                       <a
  //                         href={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
  //                         download
  //                         className="p-1 rounded-full bg-gray-100 hover:bg-gray-200 transition"
  //                         title="Télécharger l'image"
  //                       >
  //                         <Download className="w-4 h-4 text-gray-700" />
  //                       </a>
  //                     </p>
  //                     <p className="text-sm text-gray-500">
  //                       Cliquez sur l’image pour l’agrandir
  //                     </p>
  //                   </div>
  //                 )}
  //               </div>
  //               <button
  //                 onClick={closePopup}
  //                 className="absolute top-2 right-4 ml-4 text-gray-500 hover:text-gray-700 font-bold text-xl transition"
  //                 aria-label="Fermer"
  //               >
  //                 X
  //               </button>
  //             </div>

  //             {/* Image preview */}
  //             {form.uploadedFile.contentType?.startsWith("image/") && (
  //               <SlideshowLightbox className="mx-auto">
  //                 <img
  //                   src={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
  //                   alt="Aperçu"
  //                   className="max-w-full max-h-[500px] rounded-lg border cursor-zoom-in"
  //                 />
  //               </SlideshowLightbox>
  //             )}

  //             {/* PDF preview */}
  //             {form.uploadedFile.contentType === "application/pdf" && (
  //               <iframe
  //                 src={`data:application/pdf;base64,${form.uploadedFile.data}`}
  //                 title="PDF preview"
  //                 className="w-[100%] h-[90%] border mt-4"
  //               />
  //             )}
  //           </div>
  //         </>
  //       )}

  //       {form.commentaire && (
  //         <p className="mt-4 text-lg text-gray-700">
  //           <strong
  //             className={
  //               form.etatDemande === "Approuvé"
  //                 ? "text-green-600"
  //                 : form.etatDemande === "Rejeté"
  //                   ? "text-red-600"
  //                   : "text-gray-600"
  //             }
  //           >
  //             Note du traiteur :
  //           </strong>{" "}
  //           {form.commentaire}
  //         </p>
  //       )}

  //       {form.traitant?.length > 0 && (
  //         <div className="mt-8">
  //           <h3 className="text-lg font-semibold text-gray-800 mb-2">
  //             Traitants :
  //           </h3>
  //           <table className="w-full border border-gray-300 rounded-lg overflow-hidden ">
  //             <thead className="bg-gray-200">
  //               <tr>
  //                 <th className="p-3 text-left font-medium w-1/5">Nom</th>
  //                 <th className="p-3 text-left font-medium w-1/4">Email</th>
  //                 <th className="p-3 text-left font-medium w-1/6">État</th>
  //                 <th className="p-3 text-left font-medium w-1/5">
  //                   Date et heure
  //                 </th>
  //                 {form.nomFormulaire !==
  //                   "Réclamation mensuelle de dépenses" && (
  //                     <th className="p-3 text-left font-medium w-1/6">Notes</th>
  //                   )}
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {
  //                 // form.traitant.map((t, index) => (
  //                 form.traitant
  //                   ?.filter((t, index, arr) => {
  //                     // On cache la ligne "Enregistrer"
  //                     if (
  //                       t.etatDemande === "Enregistrer" &&
  //                       arr[index + 1]?.etatDemande === "En traitement"
  //                     ) {
  //                       return false;
  //                     }

  //                     // On cache la ligne "En traitement" qui suit "Enregistrer"
  //                     if (
  //                       t.etatDemande === "En traitement" &&
  //                       arr[index - 1]?.etatDemande === "Enregistrer"
  //                     ) {
  //                       return false;
  //                     }

  //                     return true;
  //                   })
  //                   .map((t, index) => (
  //                     <tr key={index} className={`bg-white `}>
  //                       <td className="border-t px-3 py-2 break-words">{t.nom}</td>
  //                       <td className="border-t px-3 py-2 break-words">
  //                         {t.email}
  //                       </td>
  //                       <td className="border-t px-3 py-2">{t.etatDemande}</td>
  //                       <td className="border-t px-3 py-2">
  //                         {formatDate(t.dateHeure)}
  //                       </td>
  //                       {form.nomFormulaire !==
  //                         "Réclamation mensuelle de dépenses" && (
  //                           <td className="border-t px-3 py-2 max-w-xs break-words whitespace-pre-wrap overflow-y-auto">{t.commentaire}</td>
  //                         )}

  //                     </tr>
  //                   ))
  //               }
  //             </tbody>
  //           </table>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
